export default [
  { to: '/manuals/viewer', display: 'Viewer', contributorsAllowed: true },
  { to: '/manuals/edit', display: 'List/Edit', contributorsAllowed: true },
  { to: '/manuals/batch-upload', display: 'Upload batch', contributorsAllowed: true },
];
